import DocumentGroupDrawer from './DocumentGroupDrawer';

export default DocumentGroupDrawer;
